/**
 * Custom file, adding MetadataScript component
 */

import { MetadataScript } from '@/components/blocks/MetadataScript/MetadataScript';
import { LayoutSlot } from '@/components/layouts/LayoutSlot';
import { layoutMainSX, widgetContainerSx } from '@/components/layouts/styles/main';
import { Layout } from '@/data/types/Layout';
import { Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC } from 'react';

export const DoubleStack: FC<{ layout: Layout }> = ({ layout }) => {
	const {
		dimensions: { contentSpacing },
	} = useTheme();

	return layout ? (
		<>
			{layout.metadata ? <MetadataScript page={layout.metadata} /> : null}
			<LayoutSlot slot={layout.slots.header} />
			<Stack
				component="main"
				gap={contentSpacing}
				alignItems="center"
				sx={layoutMainSX(layout.slots.first?.length || 0, layout.tokenName)}
			>
				<LayoutSlot slot={layout.slots.first} widgetContainerSx={widgetContainerSx} />
				<LayoutSlot slot={layout.slots.second} widgetContainerSx={widgetContainerSx} />
				<LayoutSlot slot={layout.slots.footer} />
			</Stack>
		</>
	) : null;
};
